// eslint-disable-next-line eqeqeq
const areSameValue = (sourceValue, targetValue) => sourceValue == targetValue

export default areSameValue
